var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployees(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.775 6.5C15.086 6.5 16.1405 5.46 16.1405 4.17857C16.1405 2.89714 15.086 1.85714 13.775 1.85714C12.464 1.85714 11.4 2.89714 11.4 4.17857C11.4 5.46 12.464 6.5 13.775 6.5ZM6.65 5.57143C8.227 5.57143 9.4905 4.32714 9.4905 2.78571C9.4905 1.24429 8.227 0 6.65 0C5.073 0 3.8 1.24429 3.8 2.78571C3.8 4.32714 5.073 5.57143 6.65 5.57143ZM13.775 8.35714C12.0365 8.35714 8.55 9.21143 8.55 10.9107V13H19V10.9107C19 9.21143 15.5135 8.35714 13.775 8.35714ZM6.65 7.42857C4.4365 7.42857 0 8.515 0 10.6786V13H6.65V10.9107C6.65 10.1214 6.9635 8.73786 8.9015 7.68857C8.075 7.52143 7.277 7.42857 6.65 7.42857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/Employees.6f598a83a7d1857a9b47e244b65a90f8.svg";
export { ForwardRef as ReactComponent };